import React from 'react';
import { Theme, TypeOptions } from 'react-toastify';

import Image from 'next/image';

import ErrorIcon from '@/assets/icons/auth-toast-error-icon.svg';
import SuccessIcon from '@/assets/icons/auth-toast-success-icon.svg';

interface ToastIconProps {
  theme: Theme;
  type: TypeOptions;
}

const ToastIcon = ({ type }: ToastIconProps) => {
  if (type === 'success') {
    return (
      <div className="v2-flex-shrink-0">
        <Image src={SuccessIcon} width={38} height={38} alt="Success Icon" />
      </div>
    );
  }

  if (type === 'error') {
    return (
      <div className="v2-flex-shrink-0">
        <Image src={ErrorIcon} width={38} height={38} alt="Error Icon" />
      </div>
    );
  }

  return null;
};

export default ToastIcon;
